import { useTranslation } from 'react-i18next';

import type { MedicalStaffStatus } from '../types/medical-staff.types';

// Color is an FE concern (status code → badge variant). Label comes from the backend-served
// label catalog ('labels' namespace), keyed by the wire status code. This badge has no tooltip.
const VARIANT_CLASS: Record<MedicalStaffStatus, string> = {
  ACTIVE: 'badge-success',
  PENDING: 'badge-gray',
  WITHDRAWN: 'badge-secondary',
};

interface MedicalStaffStatusBadgeProps {
  status: MedicalStaffStatus;
}

export function MedicalStaffStatusBadge({ status }: MedicalStaffStatusBadgeProps) {
  const { t } = useTranslation('labels');
  return (
    <span
      className={`badge ${VARIANT_CLASS[status]}`}
      style={{ minWidth: 76, justifyContent: 'center' }}
    >
      {t(`staffStatus.${status}`)}
    </span>
  );
}
